import { FieldViewModel } from "./exports"
import { ISeedRateMap, ISeedRatePlan } from "./types"

export function getSeedQtyForPlan(plan: ISeedRatePlan): number {

    if (!plan) {
        return
    }

    if (plan.SeedsWeight) {
        return plan.SeedsWeight
    }

    if (plan.SeedsQty) {
        return getSeedQty(plan, plan.SeedsQty)
    }

}

export function getSeedQtyForMap(plan: ISeedRatePlan, map: ISeedRateMap): number {

    if (plan && map && map.SeedsQty) {
        return getSeedQty(plan, map.SeedsQty)
    }

}

export function getSeedQty(plan: ISeedRatePlan, seedsQty: number): number {

    if (!plan) {
        return
    }

    const tgw = plan.TGW ?? (plan.UseFlatRate ? 100 : 0)

    if (tgw) {
        return Math.round((seedsQty * tgw) / 10) / 100
    }

}

export function isFieldInPlan(field: FieldViewModel, plan: ISeedRatePlan) {
    return field && field.croppings && field.croppings.some(c => isCroppingInPlan(c, plan))
}

export function isCroppingInPlan(crop: { croppingId: number }, plan: ISeedRatePlan) {
    return crop && plan && plan.Maps && plan.Maps.some(m => m.CroppingId == crop.croppingId)
}
